import { cn } from '@/shadcn-ui/utils';

interface JustMissedPillProps {
  className?: string;
}

export default function JustMissedPill({ className }: JustMissedPillProps) {
  return (
    <div
      className={cn(
        'absolute left-2 top-9 flex items-center justify-center rounded-[32px] bg-flexcar-neutral100 px-[12px] py-[8px] backdrop-blur md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2',
        className
      )}
    >
      <p className="caption-regular leading-[18px] tracking-[0.48px] text-flexcar-neutral0">
        JUST MISSED IT
      </p>
    </div>
  );
}
